/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Options/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAppointmentNotes from './AddAppointmentNotes/index'
import Notify from './Notify/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Options({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/AdditionalOptions/Content/Options"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Options.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-tY85I': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<AddAppointmentNotes
  viewPath={`${viewPath}/AddAppointmentNotes`}
/>
<Notify
  viewPath={`${viewPath}/Notify`}
/>
</div>
{children}
</React.Fragment>)
}